// extracted by mini-css-extract-plugin
export var Section = "Directors-module--Section--wSlTa";
export var LangHY = "Directors-module--LangHY--VeDJO";
export var Name = "Directors-module--Name--86Ewu";
export var Position = "Directors-module--Position--UyP7l";
export var SectionTitle = "Directors-module--SectionTitle--7q9ga";
export var Row = "Directors-module--Row--mZeAt";
export var RowSmall = "Directors-module--RowSmall--fj-Ph";
export var DirectorCard = "Directors-module--DirectorCard--Lup26";
export var Photo = "Directors-module--Photo--kS4fP";
export var MemberCard = "Directors-module--MemberCard--Em+8k";
export var Info = "Directors-module--Info--6S2VX";
export var NameRow = "Directors-module--NameRow--9GdvD";
export var Dash = "Directors-module--Dash--GnuAr";
export var arrowLeft = "Directors-module--arrowLeft--5R2jT";
export var arrowRight = "Directors-module--arrowRight--1vsXg";